// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__13b0Z","whatsIco":"styles_whatsIco__3vqMc"};